import { BsQuestionCircle } from "react-icons/bs";
import { useAuth } from "../Context/AuthContext";
import { useNavigate } from "react-router-dom";

interface menuProps {
    menuOpen: boolean;
    switchText: {
        text: string;
        nav: string;
    }
    setMenuOpen: React.Dispatch<React.SetStateAction<boolean>>;
}
const MenuDropdown : React.FC<menuProps> = ({ menuOpen, switchText, setMenuOpen }) => {
  const { user, openAuthModal, signOut } = useAuth();
  const navigate = useNavigate();

  const handleNavigation = (path: string) => {
    setMenuOpen(false);
    navigate(path);
  }

  if (!menuOpen) return null;

  return (
    <div className="absolute right-0 top-full mt-3 w-56 bg-white border border-[#FFDDA6] rounded-xl shadow-lg overflow-hidden animate-fadeIn z-50 py-2">
      <div>
        {/* Add Your Gem - always visible */}
        <div className="px-4 py-3 hover:bg-[#FFF8E7] transition-colors cursor-pointer" onClick={() => handleNavigation("/")}>
          <h4 className="font-semibold text-[#111827] text-sm">Gemio Listing</h4>
          <p className="text-xs text-gray-500">
            Head home and see what’s new around town.
          </p>
        </div>

        <div className="border-t border-[#FFDDA6]"></div>

        {/* Conditional buttons based on login state */}
        {user ? (
          <>
            <button className="w-full text-left px-4 py-2 text-sm text-[#5E503F] hover:bg-[#FFF8E7] transition-colors" onClick={() => handleNavigation("/profile")}>
              My Profile
            </button>
            <button
              className="w-full text-left px-4 py-2 text-sm text-[#5E503F] hover:bg-[#FFF8E7] transition-colors"
              onClick={signOut}
            >
              Sign Out
            </button>
          </>
        ) : (
          <button
            className="w-full text-left px-4 py-2 text-sm text-[#5E503F] hover:bg-[#FFF8E7] transition-colors"
            onClick={openAuthModal}
          >
            Login or Sign up
          </button>
        )}

        {/* Help Center - always visible */}
        <div className="border-t border-[#FFDDA6]"></div>
          <button className="flex items-center gap-1 w-full text-left px-4 py-2 text-sm text-[#5E503F] hover:bg-[#FFF8E7] transition-colors" onClick={
            () => handleNavigation("/support")
          }>
            <BsQuestionCircle /> Help Center
          </button>
      </div>

      <div className="border-t border-[#FFDDA6] px-4 py-2 text-xs text-gray-400 text-center">
        Gemio.app © {new Date().getFullYear()}
      </div>
    </div>
  );
};

export default MenuDropdown;
